export default __webpack_public_path__ + "static/media/kayi_holige.34acca80.png";